import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=b30a63a6&"
import script from "./LayoutAuth.vue?vue&type=script&lang=ts&"
export * from "./LayoutAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports